import React from 'react';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { IncludeContent } from 'bricks';
import { Heading } from 'components';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { SharedZoneBlocks, SharedZonePromoBlocks } from 'store/SharedZone/blocks/selectors';

import PromoButton from './components/PromoBlockButton';
import PromoBlockContainer from './components/PromoBlockContainer';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const PromoBlockLayout = ({
  className,
  description,
  heading,
  headlineTagName,
  isButtonHidden,
  isCompact,
  isMobile,
  isPrimary,
  list,
  markup,
}) => (
  <>
    {list ?
      <div className={cx('componentTile', { componentTiledCompact: isCompact }, className)}>
        {list.map((item) => (
          <div className={cx('componentTiled', item.className)}>
            <PromoBlockContainer
              description={item.description}
              headline={item.headline}
              imgSrc={item.imageUrl}
              isList
              isMobile={item.isMobile}
              isMobileBrowser={isMobile}
              isPrimary={item.isPrimary}
              subHeadline={item.subHeadline}
              tagName={item.headlineTagName}
            >
              <div className={cx('desctiptionWrap', isMobile && 'mobile')}>
                <div className={cx('buttonWrap')}>
                  {item.isButtonHidden ? null : (
                    <button
                      type="button"
                      className={cx('button-white')}
                      onClick={() => {
                        window.location.href = item.buttonHref;
                      }}
                    >
                      {item.buttonText}
                    </button>
                  )}
                </div>
              </div>
            </PromoBlockContainer>
            {item.markup ?
              <IncludeContent htmlContent={item.markup} />
            : null}
          </div>
        ))}
      </div>
    : <div className={cx('component', className)}>
        <PromoBlockContainer isPrimary={isPrimary}>
          {heading && (
            <Heading className={cx('heading')} level={isMobile ? 4 : 2} tagName={headlineTagName}>
              {parseHtmlToReact(heading)}
            </Heading>
          )}
          {description && <div className={cx('content')}>{parseHtmlToReact(description)}</div>}
          {isButtonHidden ? null : <PromoButton className={cx('button')} isPrimary={isPrimary} />}
        </PromoBlockContainer>
        {markup ?
          <IncludeContent htmlContent={markup} />
        : null}
      </div>
    }
  </>
);

PromoBlockLayout.propTypes = {
  className: PropTypes.string,
  description: PropTypes.node,
  heading: PropTypes.string,
  headlineTagName: PropTypes.string,
  isButtonHidden: PropTypes.bool,
  isCompact: PropTypes.bool,
  isMobile: PropTypes.bool,
  isPrimary: PropTypes.bool,
  list: PropTypes.array,
  markup: PropTypes.string,
};

const mapStateToProps = (state) => ({
  description: SharedZonePromoBlocks.getDescription(state),
  heading: SharedZoneBlocks.getHeadline(state),
  headlineTagName: SharedZoneBlocks.getHeadlineTagName(state),
  isButtonHidden: SharedZonePromoBlocks.getButtonIsHidden(state),
  isCompact: isScreenBelow640(state),
  isMobile: isScreenBelow640(state),
  isPrimary: SharedZonePromoBlocks.getIsPrimary(state),
  list: SharedZonePromoBlocks.getList(state),
  markup: SharedZonePromoBlocks.getMarkup(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(PromoBlockLayout);
